import React from 'react';
import './VOBHeader.scss';

export const VOBHeader = ({ node }) => {
    return (
        <header className="vob-header">
            <div className="kite-container">
                <div className="text">
                    <h1>{node.field_component_title}</h1>
                    {!!node.field_secondary_text && (
                        <p>{node.field_secondary_text}</p>
                    )}
                </div>
                {!!node.field_single_image && (
                    <img
                        src={
                            node.relationships.field_single_image.localFile
                                .publicURL
                        }
                        alt={node.field_single_image.alt}
                    />
                )}
            </div>
        </header>
    );
};
